(function () {
	'use strict';

	pjNoAnimate.$inject = ['$animate'];

	// prevents animation triggering by positioning a class on elements to prevent
	// excessive digest cycles.
	function pjNoAnimate($animate) {
		return {
			restrict: 'A',
			link: function (scope, element) {
				$animate.enabled(element, false);
			},
		};
	}

	angular.module('dcApp').directive('pjNoAnimate', pjNoAnimate);
})();
